import * as React from 'react'

import type {ErrorType} from './AvailabilityErrorPage'
import {AvailabilityErrorPage} from './AvailabilityErrorPage'

type OwnProps<P> = {
  getErrorMessage?: (
    props: InnerProps<P> & {
      error: ErrorType
    },
  ) => string | null | undefined
  onRetryCreator?: (props: InnerProps<P>) => () => unknown
}
type InnerProps<P> = Omit<P, keyof OwnProps<unknown>>

export function withAvailabilityResponse<P>(Component: React.ComponentType<InnerProps<P>>) {
  return function WithAvailabilityResponse({
    getErrorMessage,
    onRetryCreator,
    ...restProps
  }: OwnProps<P> & P) {
    return (
      <AvailabilityErrorPage
        getErrorMessage={
          getErrorMessage != null ? error => getErrorMessage({...restProps, error}) : null
        }
        onRetry={onRetryCreator ? onRetryCreator(restProps) : null}
      >
        <Component {...restProps} />
      </AvailabilityErrorPage>
    )
  }
}
